import { useIsMobile } from 'utils/useIsMobile'
import { PositionMetricHistoryContentLoaderResponsive } from './PositionMetricsHistoryContentLoader'
import { Banner } from 'components/Banner/Banner'
import { Typography } from 'components/Typography/Typography'
import { MetricsHistoryGraph } from './MetricsHistoryGrahp'
import { MIN_CHART_POINTS } from './utils'

export type DataPoint = {
  timestampMs: number
  [key: string]: number | undefined
}

interface Props {
  data?: DataPoint[]
  bridgeKeys?: string[]
  /** Real (stored) datapoints in `data`, excluding synthetic bridge points. */
  realPointCount?: number
  isLoading: boolean
  isError: boolean
  addMargin: boolean
  xSymbol: string
  ySymbol: string
}

export const MetricsHistoryGraphContainer = ({
  data,
  bridgeKeys,
  realPointCount,
  isLoading,
  isError,
  addMargin,
  xSymbol,
  ySymbol,
}: Props) => {
  const isMobile = useIsMobile()

  if (isLoading) {
    return <PositionMetricHistoryContentLoaderResponsive />
  }

  if ((data?.length === 0 && !isLoading) || (isError && !isLoading)) {
    return (
      <Banner variant="warning" style={{ marginTop: addMargin ? 24 : '' }}>
        <Typography variant={isMobile ? 'caption2' : 'body'} fontWeight="semiBold">
          Historical metrics are not available for this position
        </Typography>
      </Banner>
    )
  }

  if (!data) {
    return null
  }

  // Too few points to draw a meaningful line (a 1-2 point series renders as a
  // degenerate or empty plot) — the overview above already shows the values.
  if ((realPointCount ?? data.length) < MIN_CHART_POINTS) {
    return (
      <Banner variant="warning" style={{ marginTop: addMargin ? 24 : '' }}>
        <Typography variant={isMobile ? 'caption2' : 'body'} fontWeight="semiBold">
          Not enough historical data to chart this position yet
        </Typography>
      </Banner>
    )
  }

  return <MetricsHistoryGraph data={data} bridgeKeys={bridgeKeys} xSymbol={xSymbol} ySymbol={ySymbol} />
}
